var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"px-4 py-4 rounded d-theme-dark-bg",style:([{ width: _vm.width, maxWidth: _vm.width, left: _vm.left }])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }